__turbopack_context__.v({
  "html-block": "GP8bbq_html-block",
  "html-block--no-paragraph-gutters": "GP8bbq_html-block--no-paragraph-gutters",
  "html-block--on-dark": "GP8bbq_html-block--on-dark",
  "html-block--standalone": "GP8bbq_html-block--standalone",
  "standalone-section": "GP8bbq_standalone-section",
  "standalone-section--separator-bottom": "GP8bbq_standalone-section--separator-bottom",
  "standalone-section--separator-top": "GP8bbq_standalone-section--separator-top",
});
